<template>
  <div>
    <v-navigation-drawer v-model="drawer" app color="#222d32" class="  notPrint">
      <v-list dense>
               <!-- <v-row>
       
              <v-col cols="12" class="pr-4 pl-4">
                 <v-autocomplete
                 
              v-model="buscar"
              :items="linksBuscar"
              color="white"
              
              clearable
              label="Buscar"
              @change="abrirPgagina(buscar)"
              solo
              
            ></v-autocomplete>
              </v-col>
             
           
            </v-row> -->

        <template v-for="linkItem in sidebarLinkItens">
          <v-list-item
            v-if="verificarPermissao(linkItem.viewRequerid)"
            :key="linkItem.text"
            :to="linkItem.link"
          >
            <v-list-item-action>
              <v-icon color="#fff">{{ linkItem.icon }}</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title class="title-menu">
                {{ linkItem.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app  dark class="degrade">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>SIGEFIS</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu v-model="menu" bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn dark icon v-bind="attrs" v-on="on">
            <v-badge
              :content="newChamado.length"
              :value="newChamado.length"
              color="red"
              overlap
            >
              <v-icon>mdi-bell</v-icon>
            </v-badge>
          </v-btn>
        </template>

        <v-row v-for="(item, i) in newChamado" :key="i">
          <v-card
            aria-selected="true"
            class="v-list-item"
            role="listitem"
            tabindex="0"
            @click="routerNotification(item.linkRouterNotification)"
          >
            <v-icon>{{ item.icon }}</v-icon>
            <v-card-text>{{ item.textCard }}</v-card-text>
          </v-card>
        </v-row>
      </v-menu>

      <v-chip class="ma-2" color="fff" outlined pill>
        {{ $store.getters.nome }}
      </v-chip>

      <v-menu bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn dark icon v-bind="attrs" v-on="on">
            <v-icon>mdi-cogs</v-icon>
          </v-btn>
        </template>
        <v-list>
          <div class="v-list-item-group" role="listbox">
            <div
              aria-disabled="true"
              aria-selected="true"
              class="v-list-item"
              role="listitem"
              tabindex="-1"
              @click="showProfile"
            >
              Perfil
            </div>
            <div
              aria-disabled="true"
              aria-selected="true"
              class="v-list-item"
              role="listitem"
              tabindex="-1"
              @click="logout"
            >
              Sair
            </div>
          </div>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <slot></slot>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  watch: {
    menu() {
      if (this.newChamado.length > 0) {
        if (!this.menu) {
          this.newChamado = [];
          this.statusNotify = false;
        } else {
          this.statusNotify = true;
        }
      }
    },

    newChamado() {
      if (this.newChamado) {
        this.statusNotify = false;
      } else {
        this.statusNotify = true;
      }
    },
  },

  props: {
    source: String,
    listaPermissoes: [Array, Object],
  },
  sockets: {
    reciveInsert: function(data) {
      const listPermisoes = JSON.parse(this.$store.getters.listaPermissoes);
      listPermisoes.map((permissao) => {
        if (data.descricaoTela == "sincronizarTarefa") {
          if (
            data.tarefa.tipoTarefa == 0 &&
            permissao.nomePermissao == "view_tarefa"
          ) {
            this.newChamado.push({
              textCard:
                "Tarefa do numero: " +
                data.tarefa.numeroTarefa +
                " foi respondida.",
              linkRouterNotification: "/tarefas",
              icon: "mdi-clipboard-text-outline",
            });

            if (data.solicitacao.solicitado) {
              this.newChamado.push({
                textCard: "Nova Solicitação foi criada.",
                linkRouterNotification: "/solicitacoes",
                icon: "mdi-clipboard-check",
              });
            }
          }

          if (
            data.tarefa.tipoTarefa == 1 &&
            permissao.nomePermissao == "view_denuncia"
          ) {
            this.newChamado.push({
              textCard:
                "Denúncia do numero: " +
                data.tarefa.numeroTarefa +
                " foi respondida.",
              linkRouterNotification: "/denuncias",
              icon: "mdi-alert-octagon",
            });
          }

          if (
            data.tarefa.tipoTarefa == 2 &&
            permissao.nomePermissao == "view_tarefa"
          ) {
            this.newChamado.push({
              textCard:
                "Retorno do numero: " +
                data.tarefa.numeroTarefa +
                " foi respondida.",
              linkRouterNotification: "/tarefas",
              icon: "mdi-clipboard-text-outline",
            });

            if (data.solicitacao.solicitado) {
              this.newChamado.push({
                textCard: "Nova Solicitação foi criada.",
                linkRouterNotification: "/solicitacoes",
                icon: "mdi-clipboard-check",
              });
            }
          }
        }
      });
    },

    reciveUpdate: function(data) {
      console.log(data);
    },

    reciveDelete: function(data) {
      console.log(data);
    },
  },
  computed: {
    ...mapState({
      currentUser: "currentUser",
    }),
  },
  data: () => ({
    linksBuscar: [],
    buscar: null,
    menu: null,
    newChamado: [],
    dialog: false,
    drawer: null,
    statusNotify: true,

    sidebarLinkItens: [],
  }),

  created() {
    this.inicializar();
  },

  methods: {

    abrirPgagina(link){
       this.$router.push(link);
    },

    verificarPermissao(permissao) {
      const listPermisoes = JSON.parse(this.$store.getters.listaPermissoes);
      const validar = listPermisoes.filter(
        (perm) => perm.nomePermissao == permissao
      );
      if (validar.length > 0) {
        return true;
      } else {
        return false;
      }
    },

    inicializar() {
      this.sidebarLinkItens = [
        {
          icon: "mdi-monitor-dashboard",
          text: "Dashboard",
          value: "/",
          link: "/",
          viewRequerid: "view_dashboard",
        },
        {
          icon: "mdi-account-group",
          text: "Usuarios",
          value: "/usuarios",
          link: "/usuarios",
          viewRequerid: "view_usuario",
        },
        {
          icon: "mdi-account-network-outline",
          text: "Nivel",
          value: "/nivel",
          link: "/nivel",
          viewRequerid: "view_nivel",
        },
        {
          icon: "mdi-account-key-outline",
          text: "Permissao",
          value: "/permissao",
          link: "/permissao",
          viewRequerid: "view_permissao",
        },
        {
          icon: "mdi-clipboard-edit",
          text: "Roteiros",
          value: "/roteiros",
          link: "/roteiros",
          viewRequerid: "view_roteiro",
        },
        {
          icon: "mdi-clipboard-check",
          text: "Solicitações",
          value: "/solicitacoes",
          link: "/solicitacoes",
          viewRequerid: "view_solicitacao",
        },
        {
          icon: "mdi-clipboard-check",
          text: "Solicitações",
          value: "/solicitacoesAgente",
          link: "/solicitacoesAgente",
          viewRequerid: "view_solicitacao_agente",
        },
        {
          icon: "mdi-domain",
          text: "Empresa",
          value: "/empresa",
          link: "/empresa",
          viewRequerid: "view_empresa",
        },
        {
          icon: "mdi-clipboard-text-outline",
          text: "Tarefas",
          value: "/tarefas",
          link: "/tarefas",
          viewRequerid: "view_tarefa",
        },
        {
          icon: "mdi-clipboard-text-outline",
          text: "Tarefas",
          value: "/tarefasAgente",
          link: "/tarefasAgente",
          viewRequerid: "view_tarefa_agente",
        },
        {
          icon: "mdi-alert-octagon",
          text: "Denúncias",
          value: "/denuncias",
          link: "/denuncias",
          viewRequerid: "view_denuncia",
        },
         {
          icon: "mdi-map-marker-circle",
          text: "Mapa de Fiscais Em Tempo Real",
          value: "/mapaFiscaisEmTempoReal",
          link: "/mapaFiscaisEmTempoReal",
          viewRequerid: "view_mapa_fiscais",
        },
        {
          icon: "mdi-tooltip-account",
          text: "Mapa de Fiscais",
          value: "/mapaFiscais",
          link: "/mapaFiscais",
          viewRequerid: "view_mapa_fiscais",
        },
        {
          icon: "mdi-office-building-marker",
          text: "Mapa de Empresas",
          value: "/mapaEmpresas",
          link: "/mapaEmpresas",
          viewRequerid: "view_mapa_empresas",
        },
        {
          icon: "mdi-map-marker-check",
          text: "Mapa de Licenças",
          value: "/mapaLicencas",
          link: "/mapaLicencas",
          viewRequerid: "view_mapa_licencas",
        },
        {
          icon: "mdi-file-document",
          text: "Relatório de Tarefas",
          value: "/relatorioTarefas",
          link: "/relatorioTarefas",
          viewRequerid: "view_relatorio_tarefa",
        },
        {
          icon: "mdi-math-log",
          text: "Log Sistema",
          value: "/logSistema",
          link: "/logSistema",
          viewRequerid: "view_log_sistema",
        },
      ];
      
    },

    async logout() {
      this.sidebarLinkItens = [];
      await this.$store.dispatch("setListaPermissoes", this.sidebarLinkItens);
      this.$store.dispatch("logout");
      this.$router.push("/login");
    },
    showProfile() {
      this.$router.push("/perfil");
    },
    routerNotification(linkRouterNotification) {
      this.$router.push(linkRouterNotification);
    },
  },
};
</script>

<style scoped>
.title-menu {
  color: #fff;
}
.print {
  display: none;
}
@media print {
  .notPrint {
    display: none;
  }
  .print {
    display: block;
  }
}
.degrade{
 background: rgb(2,177,238);
 background: linear-gradient(90deg, rgba(2,177,238,1) 0%, rgba(37,197,213,1) 90%);
/* background-color: #222d32; */
}
</style>
